import * as React from 'react';

export default function ReferencesTileImage({ src, className, alt }) {
    if (!src) return null;

    const fileNameToSize = (url, size, format = 'webp') => `${url}/m/${size}x0/filters:format(${format})`;
    const [rawWidth, rawHeight] = src?.split('/')[5]?.split('x') || [];
    const width = Number.parseInt(rawWidth, 10);
    const height = Number.parseInt(rawHeight, 10);

    return (
        <picture>
            <source
                type="image/avif"
                srcSet={`
                    ${fileNameToSize(src, 400, 'avif')} 400w,
                    ${fileNameToSize(src, 600, 'avif')} 600w,
                    ${fileNameToSize(src, 800, 'avif')} 800w,
                    ${fileNameToSize(src, 1000, 'avif')} 1000w,
                    ${fileNameToSize(src, 1200, 'avif')} 1200w`}
                sizes="(max-width: 768px) 50vw, (max-width: 1280px) 33vw, 25vw"
            />
            <img
                src={fileNameToSize(src, 800)}
                className={className || 'w-auto object-cover h-full'}
                alt={alt || 'Reference link'}
                width={Number.isNaN(width) ? undefined : width}
                height={Number.isNaN(height) ? undefined : height}
                srcSet={`
                    ${fileNameToSize(src, 400)} 400w,
                    ${fileNameToSize(src, 600)} 600w,
                    ${fileNameToSize(src, 800)} 800w,
                    ${fileNameToSize(src, 1000)} 1000w,
                    ${fileNameToSize(src, 1200)} 1200w`}
                sizes="(max-width: 768px) 50vw, (max-width: 1280px) 33vw, 25vw"
                loading="lazy"
            />
        </picture>
    );
}